module.exports = __webpack_public_path__ + "img/redhat-hero.fda80aec.webp";